const de = {
    registerPage: {
        accountType: 'Konto-Typ',
        noCreditCardRequired: 'Keine Kreditkarte erforderlich, starten Sie Ihr',
        freeTrial: 'kostenloser Test',
        today: 'heute',
        firstname: 'Vornamen',
        phoneNumber: 'Telefonnummer',
        software: 'Software',
        softwarePlusScreening: 'Software + Screening',
        easyAndSecure: 'Einfach und sicher',
        chargedYearly: 'jährliche Gebühr',
        secureWhistleblowerPlatform: 'Sichere Whistleblower-Plattform',
        tailoredWhistleblowerPolicy: 'Individuelle Whistleblower-Richtlinie',
        reportManagement: 'Verwaltung der Berichte',
        followUpCommunication: 'Nachfassende Kommunikation',
        emailNotifications: 'E-Mail-Benachrichtigungen',
        employeeGuides: 'Leitfäden für Mitarbeiter',
        areYouLookingFo: 'Sind Sie auf der Suche nach unserem Partnerprogramm?',
        partnerprogrammodal: 'Partner Program',
        iHaveAgreedToWalor:
            'Ich habe die Walor-Bedingungen gelesen und akzeptiere sie',
        termsAndConditions: 'Bedingungen und Konditionen',
        and: 'und',
        privacyAndCookiePolicy: 'Datenschutz und Cookie-Richtlinie',
        dataProcessingAgreement: 'Vereinbarung zur Datenverarbeitung',
        ifYouAreLookingFor:
            'Wenn Sie auf der Suche nach einem Partnerprogramm sind, kontaktieren Sie uns unter',
        thanksCheckYour: 'Erledigt! Überprüfen Sie Ihre E-Mails.',
        rememberToCheckYourSpam:
            'Haben Sie die E-Mail nicht erhalten? Bitte überprüfen Sie Ihren Spam-Ordner oder kontaktieren Sie uns unter',
        areYouAMemberOf: 'Sind Sie Mitglied bei',
        mcdonaldsOnboardingTagline:
            "McDonald's Onboarding, es dauert nur wenige Minuten!",
    },
    onboardingPage: {
        hi: 'Guten Tag',
        welcomeToWalor: 'willkommen bei Walor!',
        youAreAlmostDone:
            'Sie sind fast fertig mit dem Einrichten Ihrer neuen Lösung',
        insertCompanyInformation: 'Informationen zum Unternehmen',
        subcreateYourCompanyInformation:
            'Fügen Sie die Adresse des Unternehmens und die Anzahl der Mitarbeiter hinzu.',
        generateWhistleblowerPolicy: 'Whistleblower-Politik',
        readyToGo: 'Fangen wir an',
        pleaseFillinThisInformation:
            'Geben Sie Ihre Unternehmensinformationen ein',
        nextStep: 'Nächster Schritt',
        name: 'Name des Unternehmens',
        createYourLineOfContact: 'Erstellen Sie Ihre Kontaktlinie',
        skipThisStep: 'Diesen Schritt überspringen',
        subcreateYourLineOfContact:
            'Diese Benutzer sind für die Bearbeitung von Whistleblowing-Meldungen in Ihrer Organisation zuständig.',
        subgenerateyourwbpolicy:
            'Hier wird der rechtliche Rahmen für Ihre Whistleblowing-Lösung beschrieben.',
        clickHere: 'Klicken Sie hier',
        complete: 'Vollständig',
        yourWhistleblowerpolicyIsBeingGenerated:
            'Ihre Whistleblower-Politik wird in diesem Moment erstellt',
        goodWork: 'Herzlichen Glückwunsch',
        yourPolicyHasBeen: 'Ihre Whistleblower-Richtlinie wurde erstellt!',
        allSetEasy: 'Alles klar! Einfach, oder?',
        letsGetYouStarted: 'Fangen wir gleich damit an',
        takeMeToTheDashboard: 'Bringen Sie mich zum Dashboard',
    },
    onboardingFlow: {
        enterCompanyNumber: 'Nummer des Unternehmens',
        enterCompanyName: 'Name des Unternehmens',
        enterPhone: '12345678',
        enterAddress: 'Adresse',
        enterCity: 'Stadt',
        enterZipCode: '1234',
    },
    loginFlow: {
        login: 'Anmeldung',
        forgotPassword: 'Passwort vergessen?',
        underPageForgotPassword: 'Passwort vergessen?',
        underPageWriteYourEmail:
            'Geben Sie unten Ihre E-Mail-Adresse ein, um ein neues Passwort zu erstellen',
        howDoYouWant: 'Wie möchten Sie Ihren Sicherheitscode erhalten?',
        buttonEmail: 'E-Mail',
        buttonSMS: 'SMS',
        or: 'oder',
        backToLogin: 'Zurück zur Anmeldung',
        enterThe6digit: 'Geben Sie den 6-stelligen Code ein',
        yourCodeWillArrive:
            'Ihr Code wird in wenigen Sekunden an folgende Adresse gesendet',
        didYouNotReceive:
            'Haben Sie den Code nicht erhalten? Klicken Sie hier, um ihn erneut zu senden',
    },
    whistleblowerCreateCase: {
        whistleblowerScheme: 'Whistleblower-Meldekanal',
        grievanceAndWhistleblowerScheme:
            'Beschwerde- und Whistleblower-Meldekanal',
        createReport: 'Bericht erstellen',
        startReport: 'Initiieren Sie eine anonyme und sichere Meldung',
        startReportConfidential: 'Vertraulichen Bericht erstellen',
        accessExistingReport: 'Zugriff auf bestehenden Bericht',
        understandWhistleblowing: 'Informieren Sie sich über Whistleblowing',
        understandGrievanceAndWhistleblower:
            'Informieren Sie sich über Beschwerden und Whistleblowing',
        readMore: 'Leitfäden für Mitarbeiter',
        playvideo: 'Spielen',
        howThisWorks: 'Wie das funktioniert',
        createAReport: 'Einen Bericht erstellen',
        createAReportOris:
            'Erstellen Sie einen anonymen oder vertraulichen Bericht. Sie können die von Ihnen gesammelten Informationen und Dateien bereitstellen. Bitte beachten Sie, dass das Whistleblower-System auf freiwilliger Basis eingerichtet wurde und daher nicht unter das Whistleblower-Gesetz fällt, was zur Folge hat, dass (i) Berichte keine sogenannten „sensiblen personenbezogenen Daten” enthalten dürfen, darunter Informationen, die Rückschlüsse auf die Identität von Patienten zulassen, und (ii) der im Whistleblower-Gesetz festgelegte besondere Schutz für Whistleblower nicht gilt. Als Mitarbeiter von ORIS Dentists garantieren wir Ihnen jedoch im Rahmen Ihres Arbeitsverhältnisses einen ähnlichen Schutz. Nachdem Sie die Meldung abgeschickt haben, erhalten Sie einen eindeutigen Whistleblower-Code, mit dem Sie erneut auf die Meldung zugreifen können.',
        createAReportSimply:
            'Erstellen Sie eine anonyme oder vertrauliche Meldung. Sie können alle Informationen und Dateien, die Sie gesammelt haben, zur Verfügung stellen. Sobald Sie die Meldung abgeschickt haben, erhalten Sie einen eindeutigen Whistleblower-Code, mit dem Sie die Meldung erneut aufrufen können.',
        investigatingthereport: 'Interne Untersuchung',
        caseworkerinthecompany:
            'Die Sachbearbeiter, die Sie für die Bearbeitung Ihrer Meldung ausgewählt haben, werden per E-Mail benachrichtigt, damit sie mit der internen Untersuchung beginnen können.',
        answeradditionalquestions: 'Zusätzliche Fragen beantworten',
        additionalQuestions:
            'Die Sachbearbeiter, die Sie auswählen, könnten zusätzliche Fragen zu Ihrem Bericht haben. Stellen Sie sicher, dass Sie Ihren Bericht von Zeit zu Zeit erneut eingeben, um die interne Untersuchung zu unterstützen.',
        companiesWhistleblowerPolicy: 'Whistleblower-Politik',
        companiesGrievanceAndWhistleblowerPolicy:
            'Beschwerde- und Whistleblower-Politik',
        privacyPolicy: 'Datenschutzerklärung',
    },
    whistleblowerHowItWorksPage: {
        whistleblowing: 'Whistleblowing im Allgemeinen',
        whatIsWhistleblowing: 'Was ist Whistleblowing?',
        whistleblowingDefinition:
            'Unter Whistleblowing versteht man die Meldung von illegalen oder unmoralischen Handlungen innerhalb einer Organisation durch eine Einzelperson. Die Person, die dies meldet, der so genannte Whistleblower, kann entweder Teil dieser Organisation oder ein Dritter sein, der mit der Organisation in Verbindung steht.',
        whereItsUseful:
            'In der überwiegenden Mehrheit der Fälle findet Whistleblowing in einem arbeitsbezogenen Kontext statt. Ein Arbeitnehmer*in könnte beispielsweise bei der Ausübung seiner Arbeit Informationen über illegale Aktivitäten seines Arbeitgebers erhalten, die er zu melden beschließt.',
        whatAreTheTypes: 'Welche Arten von Whistleblowing gibt es?',
        typesOfWhistleblowing:
            'Es kann zwischen internem und externem Whistleblowing unterschieden werden. Internes Whistleblowing bedeutet, dass ein Hinweisgeber*in eine Meldung innerhalb der Organisation macht, der er angehört oder mit der er verbunden ist. Das bedeutet, dass der Whistleblower*in das Fehlverhalten nur innerhalb dieser Organisation mitteilt. Externes Whistleblowing hingegen bedeutet, dass der Hinweisgeber andere Personen als die Organisation selbst auf Aktivitäten dieser Organisation aufmerksam macht. In diesem Fall werden die Informationen z. B. an Behörden oder die Medien weitergegeben.',
        whatIsTheImportance:
            'Wieso spielt das Whistleblowing eine wichtige Rolle?',
        preventionOrReparation:
            'Zunächst einmal spielt Whistleblowing eine wesentliche Rolle bei der Verhinderung oder Wiedergutmachung von Schäden für das öffentliche Interesse, da Personen, die einer Organisation angehören oder mit ihr in Verbindung stehen, oft die ersten oder einzigen sind, die Kenntnis von oder Zugang zu Informationen über solche Schäden haben.',
        ethicCulture:
            'Darüber hinaus trägt Whistleblowing aus Sicht der Organisation zu einer Kultur der Ethik, Rechtmäßigkeit, Transparenz und Beteiligung bei.',
        whistleblowerSafety:
            'Schließlich ermöglicht Whistleblowing dem Whistleblower*in die Überwindung von Schuldgefühlen oder Verantwortungsbewusstsein, nachdem Sie Informationen über illegale oder unmoralische Handlungen in dem Unternehmen erhalten hat, dem Sie angehört oder mit dem Sie in Verbindung steht.',
        whistleblowerImportance:
            'Aufgrund dieser Bedeutung ist der Schutz von Hinweisgebern gesetzlich verankert.',
        whistleblowerScheme: 'Whistleblower-Regelung',
        grievanceAndWhistleblowerScheme:
            'Beschwerde- und Whistleblower-Regelung',
        whatIsWhistleblowerScheme: 'Was ist eine Whistleblower-Regelung?',
        whistleblowerIsATool:
            'Ein Whistleblower-System ist ein Instrument, das es Menschen ermöglicht, Meldungen über eine bestimmte Organisation zu machen. Dieses System leitet Hinweisgeber*innen durch den Prozess der Meldung einer illegalen oder unethischen Tätigkeit. Auf diese Weise können Organisationen von illegalem oder unethischem Verhalten erfahren, es untersuchen und abstellen.',
        whyHaveAWhistleBlowerScheme:
            'Warum brauchen Sie eine Whistleblower-Regelung?',
        whistleblowerLaw:
            'Nachdem die Europäische Union den Wert von Whistleblowing stärker in den Mittelpunkt gestellt hat, hat die EU am 23. Oktober 2019 die Richtlinie 2019/1937 zum Schutz von Personen, die Verstöße gegen das Unionsrecht melden, verabschiedet. Diese Whistleblower-Richtlinie, die in dänisches Recht umgesetzt wurde, bietet einen rechtlichen Rahmen für Whistleblowing-Systeme und schützt Whistleblower, die Informationen über ein Whistleblower-System melden.',
        whistleblowingSchemeTransparency:
            'Das Whistleblowing-System ermöglicht es jedem, sich zu äußern und sein Recht auf Gehör wahrzunehmen, was für die Schaffung einer Kultur der Transparenz und des Zugehörigkeitsgefühls von wesentlicher Bedeutung ist. Darüber hinaus unterstützt und ermutigt dieses System dazu, Bedenken intern zu äußern, nahe an der Quelle des Problems. Dies ermöglicht eine frühzeitige und wirksame Beseitigung dieser Probleme.',
        whoCanUseThisWhistleblowerScheme:
            'Wer kann diese Whistleblower-Regelung in Anspruch nehmen?',
        anyoneCanUse:
            'Die Whistleblower-Regelung kann von allen Personen in Anspruch genommen werden, die über Informationen über eine öffentliche oder private Organisation verfügen, die sie im Rahmen ihrer beruflichen Tätigkeit erhalten haben.',
        categoriesOfPeople:
            'Die Kategorien von Personen, die dieses System zur Meldung von Missständen nutzen können, sind breit gefächert. Meldungen können also eingereicht werden von:',
        people1:
            'Arbeitnehmer. Dies gilt sowohl für Voll- und Teilzeitbeschäftigte als auch für Arbeitnehmer mit einem unbefristeten oder befristeten Arbeitsvertrag.',
        people2: 'Stellenbewerber',
        people3: 'Bezahlte oder unbezahlte Praktikanten',
        people4: 'Ehrenamtliche Mitarbeiter',
        people5: 'Selbstständig Erwerbstätige',
        people6: 'Aktionäre',
        people7:
            'Mitglieder der Geschäftsführung, des Aufsichtsrats oder eines anderen Leitungsorgans',
        people8:
            'Personen, die unter der Aufsicht und Leitung von Auftragnehmern, Unterauftragnehmern und Lieferanten arbeiten',
        noMatterTheRelationship:
            'Personen, die unter diese Kategorien fallen, können das Whistleblowing-System in Anspruch nehmen, unabhängig davon, ob ihr Arbeitsverhältnis mit der Organisation beendet ist, noch andauert oder noch nicht begonnen hat.',
        whatCanBeReported:
            'Was kann im Rahmen des Whistleblower-Systems gemeldet werden?',
        seriousViolations:
            'Das Whistleblower-System kann genutzt werden, um Informationen über schwerwiegende Gesetzesverstöße, Versuche, solche Verstöße zu verbergen, oder andere schwerwiegende Angelegenheiten, die in einer Organisation aufgetreten sind oder wahrscheinlich auftreten werden, zu melden. Auch bei einem begründeten Verdacht auf das Auftreten solcher Verstöße oder Angelegenheiten können diese Informationen gemeldet werden.',
        violationsOfLaw:
            'Die Verstöße, die über das Whistleblower-System gemeldet werden können, beziehen sich auf spezifische Verstöße gegen EU-Recht oder andere schwerwiegende Straftaten und Angelegenheiten nach dänischem Recht. Aktivitäten, die über dieses System gemeldet werden können, beziehen sich beispielsweise auf Korruption, Umweltschutz, öffentliche Gesundheit, Privatsphäre und persönliche Daten oder sexuelle Belästigung und sexuellen Missbrauch. Dies sind nur Beispiele. Auch andere Angelegenheiten oder schwerwiegende Verstöße gegen das Gesetz können gemeldet werden.',
        whatCantBeReported:
            'Was kann im Rahmen dieser Regelung für Hinweisgeber nicht gemeldet werden?',
        lessSeriousMatters:
            'Das Whistleblower-System ist nicht dazu gedacht, weniger schwerwiegende Angelegenheiten oder gewöhnliche Beschäftigungsprobleme zu melden, wie z. B. Unzufriedenheit mit dem Gehalt oder kleinere kollegiale Probleme. Darüber hinaus sind Meldungen, die nicht in gutem Glauben erfolgen und offensichtlich unbegründet sind, nicht vorgesehen.',
        inCaseOfDoubt:
            'Wenn Sie Zweifel haben, ob eine Beobachtung oder ein Verdacht ernst zu nehmen ist und gemeldet werden sollte oder nicht, werden Sie dennoch dazu ermutigt, dies zu tun. Alle Anfragen werden beantwortet und bearbeitet.',
        howAreYouProtected:
            'Wie sind Sie bei der Nutzung dieser Regelung geschützt?',
        noLiability:
            'Whistleblower, die in gutem Glauben schwerwiegende Angelegenheiten im Rahmen dieser Regelung melden, genießen umfassenden Schutz, ohne dass sie für die Verletzung einer Vertraulichkeitspflicht in Bezug auf die gemeldeten Informationen haftbar gemacht werden können. Alle Personen und Unternehmen, die den Whistleblower unterstützen, und auch die mit dem Whistleblower verbunden sind, fallen unter diesen Schutz.',
        noRetaliation:
            'Dieser Schutz beinhaltet einen Schutz gegen jegliche Form von Vergeltung. Vergeltungsmaßnahmen sind alle Maßnahmen oder Unterlassungen, die sich aus der Meldung ergeben und dem Hinweisgeber einen ungerechtfertigten Schaden zufügen oder zufügen können. Solche Maßnahmen können verschiedene Formen annehmen, wie z. B. Entlassung, Wechsel des Arbeitsortes, Lohnkürzung oder Schädigung des persönlichen oder beruflichen Rufs. Wenn ein Hinweisgeber oder eine geschützte Person Vergeltungsmaßnahmen erleidet, wird er oder sie dafür entschädigt. Eine Organisation, die Vergeltungsmaßnahmen ergreift, kann auch mit anderen Sanktionen belegt werden.',
        howDoesTheProcessWork:
            'Wie funktioniert der Prozess der Berichterstattung?',
        howDoIReport: 'Wie kann ich einen Bericht erstellen?',
        reportingChannel:
            'Sie können einen Bericht über den digitalen Berichtskanal der Organisation erstellen, über die Sie berichten möchten.',
        whatIfIncomplete: 'Was passiert, wenn mein Bericht unvollständig ist?',
        accessAndExpand:
            'Sie haben jederzeit die Möglichkeit, Ihren Bericht einzusehen und ihn durch zusätzliche Angaben oder Beweise zu ergänzen. Die mit dem Fall befassten Personen können auch zusätzliche Fragen oder Unterlagen anfordern, die für die Bearbeitung und Untersuchung der Meldung relevant sein können. Eine nachträgliche Übermittlung von Antworten oder Unterlagen hängt jedoch ausschließlich von Ihrer Bereitschaft ab, dies zu tun. Eine Verpflichtung dazu besteht nicht.',
        whoIsProccessing: 'Wer bearbeitet meinen Bericht?',
        thirdParty:
            'Ihre Meldung wird von der/den ausgewählten Person(en) in der Whistleblowing-Stelle des Unternehmens bearbeitet. Nur diese Personen sind befugt, eine Untersuchung durchzuführen. Unter keinen Umständen wird Ihr Fall einer Person anvertraut, die an den gemeldeten Aktivitäten beteiligt ist oder mit der ein Interessenkonflikt bestehen könnte.',
        howIsProccessed: 'Wie wird mein Bericht bearbeitet?',
        investigations:
            'Sie erhalten innerhalb von sieben Tagen eine Empfangsbestätigung für den Bericht. Danach wird eine erste Prüfung der Meldung vorgenommen. Erweist sich die Meldung als besonders unbegründet, wird sie abgelehnt. Sie erhalten so schnell wie möglich eine entsprechende Mitteilung. Stellt sich jedoch bei der ersten Prüfung heraus, dass Ihre Meldung nicht als besonders unbegründet eingestuft werden kann, wird sie weiter untersucht. Ihr Fall wird dann intern bearbeitet. Diese interne Untersuchung kann Folgen für die betroffene(n) Person(en) haben. Handelt es sich um einen besonders schwerwiegenden Fall, kann er auch an die Polizei zur weiteren Untersuchung weitergeleitet werden. Nach Durchführung aller Ermittlungen und der Verhängung möglicher Sanktionen wird der Fall abgeschlossen. Er wird dann aus dem System gelöscht.',
        whatIfLooseCode:
            'Was ist, wenn ich meinen Whistleblower-Code verliere?',
        looseAccess:
            'Sollte der Hinweisgeber-Code verloren gehen, haben Sie leider keinen Zugang mehr zu Ihrer Meldung. Dies ist die einzige Möglichkeit, eine sichere und anonyme Meldung zu gewährleisten. Ihre Meldung wird jedoch weiterhin geprüft und untersucht.',
        unableToUptade:
            'Sie werden nicht in der Lage sein, Ihre Meldung zu aktualisieren oder erhaltene Fragen zu der Meldung zu beantworten. Um dies zu tun, müssen Sie eine neue Meldung machen und diese über das Whistleblowing-System einreichen.',
        howLongDoesItTake:
            'Wie lange dauert es, bis mein Bericht bearbeitet wird?',
        whithin3Months:
            'Ihre Meldung wird so schnell wie möglich bearbeitet und untersucht. Während dieses Prozesses erhalten Sie eine Rückmeldung über etwaige Aktualisierungen oder Ergebnisse. Die Gesamtdauer hängt von Ihrem Fall ab, aber Sie erhalten spätestens innerhalb von drei Monaten nach der Meldung Informationen über die geplanten oder ergriffenen Maßnahmen.',
        willIRemainSecret: 'Wird meine Identität geheim bleiben?',
        anounOrConfidential:
            'Sie haben die Möglichkeit, Ihre Meldung entweder anonym oder vertraulich im Rahmen des Whistleblower-Systems abzugeben. Ersteres bedeutet, dass keine persönlichen Informationen weitergegeben werden, während letzteres die Weitergabe von persönlichen Informationen durch den Hinweisgeber beinhaltet. Wenn Sie in Ihrer Meldung personenbezogene Informationen weitergeben, haben nur diejenigen, die zur Untersuchung des Falls befugt sind, Zugang dazu. Die Vertraulichkeit der eingereichten Meldung wird daher auf jeden Fall gewahrt.',
        willPersonsBeNotified:
            'Werden die betroffenen Personen in einem Bericht benachrichtigt?',
        concernedsNotified:
            'Die betroffene(n) Person(en) wird/werden über ihre Beteiligung an einer Meldung informiert. In jedem Einzelfall wird geprüft, wann diese Mitteilung weitergegeben werden kann, damit die Mitteilung keine Auswirkungen auf die Beweiserhebung hat.',
        noPersonalInfo:
            'Es werden weder direkt noch indirekt Angaben darüber gemacht, wer die Meldung an die betreffende Person gemacht hat, selbst wenn Sie sich für eine vertrauliche Meldung entschieden haben und daher Ihre Identität preisgeben.',
        isSchemeSecured: 'Ist diese Whistleblower-Regelung gesichert?',
        independencyGuarantee:
            'Der Whistleblower-Meldekanal wird von Walor ApS betrieben, einer unabhängigen dritten Partei, die die Sicherheit des Systems garantiert. Das System protokolliert keine IP-Adressen und Maschinen-IDs und verschlüsselt alle verarbeiteten Daten. Die Rechte aller Beteiligten auf personenbezogene Daten werden gewahrt. Nur der zuständige Sachbearbeiter hat Zugriff auf den Bericht.',
        whatIfImDissatisfied:
            'Was ist, wenn ich mit der Bewertung oder dem Ergebnis meines Berichts nicht zufrieden bin?',
        informCompetentAuth:
            'Es ist immer möglich, weitere Maßnahmen zu ergreifen, wenn Sie der Meinung sind, dass es dafür Gründe gibt. Ein negativer Ausgang einer Meldung hindert Sie in keinem Fall daran, dies zu tun. Nach der Meldung über das Whistleblower-System können Sie die Informationen an die zuständigen Behörden weiterleiten. Darüber hinaus können Meldungen gegebenenfalls auch an Organe, Einrichtungen, Ämter oder Agenturen der Europäischen Union gerichtet werden.',
    },
    whistleblowerPolicyPage: {
        whistleblowerPolicyHeading: 'Whistleblower-Politik',
        backToHomescreen: 'Zurück zum Startbildschirm',
        whistleblowerPolicy: 'die Whistleblower-Politik',
        thePurposeOfThisWhistleblower:
            'Der Zweck dieser Whistleblower-Politik ist es, zu erklären, wie',
        whistleblowerSchemeWorks:
            'das Whistleblower-System funktioniert. Im Rahmen dieses Systems können Sie Meldungen machen über',
        aGoodUnderstanding:
            'Ein gutes Verständnis dieser Regelung kann daher verhindern, dass potenziell wichtige Angelegenheiten nicht gemeldet werden.',
        introductionTo: 'Einführung in',
        whistleblowerScheme: 'Die Whistleblower-Regelung',
        isAResponsibleCompanyWith:
            'ist ein verantwortungsbewusstes Unternehmen mit einer offenen Kultur, in der sich jeder sicher fühlen und seine Meinung äußern kann, wenn er ein Fehlverhalten oder einen potenziellen Verstoß gegen das Gesetz feststellt. Zunächst ist es immer möglich und wird nachdrücklich befürwortet, in solchen Situationen mit einem direkten Vorgesetzten oder einem Mitglied der Geschäftsleitung (Vorstand) zu sprechen, aber es ist auch möglich, den Meldeweg für Hinweisgeber zu nutzen.',
        whistleblowerSchemeEnsuresProtection:
            'Die Whistleblower-Regelung der Kommission gewährleistet den Schutz von Personen, die schwerwiegende Verstöße und Angelegenheiten melden. Diese Regelung kann in Anspruch genommen werden, wenn Sie von solchen Verstößen erfahren, davon Kenntnis haben oder Grund zu der Annahme haben, dass sie in folgenden Bereichen auftreten',
        bothInThePast:
            'sowohl in der Vergangenheit als auch in der Gegenwart oder der nahen Zukunft. Meldungen können entweder anonym oder vertraulich eingereicht werden.',
        whoCanUseThisWhistleblowingScheme:
            'Wer kann diese Whistleblowing-Regelung in Anspruch nehmen?',
        whistleblowerSchemeCanBeUsedByAnyone:
            'Das Whistleblower-System kann von jedem genutzt werden, der Informationen über',
        whichTheyHaveAcquired:
            'die sie im Rahmen ihrer beruflichen Tätigkeit erworben haben, mit',
        theCategoriesOfPeopleWho:
            'Die Kategorien von Personen, die dieses System zur Meldung von Missständen nutzen können, sind breit gefächert. Meldungen können also eingereicht werden von:',
        employees:
            'Arbeitnehmer. Dies gilt sowohl für Voll- und Teilzeitbeschäftigte als auch für Arbeitnehmer mit einem unbefristeten oder befristeten Arbeitsvertrag.',
        jobApplicants: 'Stellenbewerber',
        paidOrUnpaidTrainees: 'Bezahlte oder unbezahlte Praktikanten',
        volunteers: 'Ehrenamtliche Mitarbeiter',
        selfEmployedPersons: 'Selbstständig Erwerbstätige',
        shareholders: 'Aktionäre',
        membersOfTheManagement:
            'Mitglieder des Vorstands, des Aufsichtsrats oder eines anderen Leitungsorgans von',
        personsWorkingUnder:
            'Personen, die arbeiten unter der Aufsicht und Leitung von Auftragnehmern, Unterauftragnehmern und Lieferanten von',
        personsFallingUnderTheseCategories:
            'Personen, die unter diese Kategorien fallen, können das Whistleblowing-System in Anspruch nehmen, unabhängig davon, ob sie in einem Arbeitsverhältnis stehen mit',
        hasCeased:
            'eingestellt wurde, noch läuft oder noch nicht begonnen hat.',
        whatCanYouReport: 'Was können Sie melden?',
        theWhistleblowerSchemeCanBeUsed:
            'Die Whistleblower-Regelung kann genutzt werden, um Informationen über schwerwiegende Gesetzesverstöße, Versuche, solche Verstöße zu verheimlichen, oder andere schwerwiegende Angelegenheiten, die in den folgenden Bereichen aufgetreten sind oder wahrscheinlich auftreten werden, zu melden',
        alsoInTheCaseOfRasonable:
            'Auch bei einem begründeten Verdacht auf das Auftreten dieser Verstöße oder Angelegenheiten können diese Informationen gemeldet werden. Es ist jedoch erforderlich, dass die Meldungen in gutem Glauben erfolgen und dass dieses Meldesystem nicht für unbegründete Anschuldigungen gegenüber unschuldigen Personen genutzt wird.',
        theViolationsWhich:
            'Die Verstöße, die über das Whistleblower-System gemeldet werden können, beziehen sich auf spezifische Verstöße gegen EU-Recht oder andere schwerwiegende Vergehen und Angelegenheiten nach dänischem Recht. Weniger schwerwiegende Angelegenheiten oder gewöhnliche Beschäftigungsprobleme, wie Unzufriedenheit mit dem Gehalt oder kleinere kollegiale Probleme, sind nicht dafür gedacht, über dieses Hinweisgebersystem gemeldet zu werden.',
        activitesThatCanBeReported:
            'Aktivitäten, die im Rahmen dieses Systems gemeldet werden können, beziehen sich beispielsweise auf Korruption, Umweltschutz, öffentliche Gesundheit, Privatsphäre und persönliche Daten oder sexuelle Belästigung und sexuellen Missbrauch. Dies sind nur Beispiele. Auch andere Angelegenheiten oder schwerwiegende Verstöße gegen das Gesetz können gemeldet werden.',
        ifYouAreInDoubtAbout:
            'Wenn Sie im Zweifel sind, ob Ihre Beobachtung oder Ihr Verdacht ernst zu nehmen ist und gemeldet werden sollte oder nicht, werden Sie dazu ermutigt, dies zu tun. Alle Anfragen werden beantwortet und bearbeitet.',
        protectionOfWhistleblowers: 'Schutz von Whistleblowern',
        anyoneWhoReportsMatters:
            'Jeder, der in gutem Glauben die oben beschriebenen Angelegenheiten meldet, ist vor jeder Form von Vergeltung geschützt. Vergeltungsmaßnahmen sind direkte oder indirekte Handlungen oder Unterlassungen, die in einem arbeitsbezogenen Kontext als Folge der Meldung erfolgen und die dem Hinweisgeber einen ungerechtfertigten Schaden zufügen können. Solche Maßnahmen können verschiedene Formen annehmen, wie z. B. Entlassung, Wechsel des Arbeitsortes, Lohnkürzung oder Schädigung des Rufes des Hinweisgebers.',
        ifAWhistleblowerSuffers:
            'Wenn ein Hinweisgeber in irgendeiner Form Vergeltungsmaßnahmen erleidet durch',
        heOrSheWillBeCompensated:
            'er oder sie wird dafür entschädigt. Im Falle einer Entlassung wird die Entlassung aufgehoben und das Arbeitsverhältnis aufrechterhalten oder wiederhergestellt, wenn der Hinweisgeber dies wünscht.',
        mayAlsoBeSubjectToOtherSanctions:
            'können auch mit anderen Sanktionen belegt werden.',
        howToReport: 'Wie kann man sich melden?',
        reportsThatLieWithin:
            'Meldungen, die in den Anwendungsbereich dieser Politik fallen, werden von der oder den ausgewählten Personen in der vereinbarten Kontaktlinie des Unternehmens bearbeitet, das sind:',
        onlyThesePersonsAreAuthorised:
            'Nur diese Personen sind befugt, eine Untersuchung durchzuführen. In einigen Fällen kann die Untersuchung jedoch mit Hilfe externer Parteien, wie Anwälten oder Wirtschaftsprüfern, durchgeführt werden.',
        howAreTheReportsProcessed: 'Wie werden die Berichte bearbeitet?',
        youWilRecieveAnAcknowledgement:
            'Sie erhalten innerhalb von sieben Tagen eine Empfangsbestätigung für den Bericht. Danach wird eine erste Prüfung der Meldung vorgenommen. Erweist sich die Meldung als besonders unbegründet, wird sie zurückgewiesen. Die Person, die den Fall gemeldet hat, wird hiervon so schnell wie möglich in Kenntnis gesetzt. Stellt sich jedoch bei der ersten Prüfung heraus, dass die Meldung nicht als besonders unbegründet eingestuft werden kann, wird sie weiter untersucht. Der Fall wird dann intern bearbeitet. Der Hinweisgeber erhält so bald wie möglich eine Rückmeldung über etwaige Aktualisierungen oder Ergebnisse. Diese interne Untersuchung kann Folgen für die betroffene(n) Person(en) haben. Handelt es sich um einen besonders schwerwiegenden Fall, kann er auch an die Polizei zur weiteren Untersuchung weitergeleitet werden. Nach Durchführung aller Ermittlungen und der Verhängung möglicher Sanktionen wird der Fall geschlossen. Er wird dann aus dem System gelöscht.',
        subsequentClarificationAndCollection:
            'Nachträgliche Klärung und Einholung zusätzlicher Unterlagen',
        whenYouCreateAReport:
            'Wenn Sie eine Meldung erstellen, haben Sie die Möglichkeit, sich in das System einzuloggen und zu sehen, ob der Sachbearbeiter zusätzliche Fragen zu dem Fall gestellt oder zusätzliche Unterlagen angefordert hat. Jeder weitere Dialog hängt ausschließlich von der Bereitschaft des Hinweisgebers ab, sich in das System einzuloggen und die Fragen des Sachbearbeiters zu beantworten.',
        confidentialityAndITSecurity: 'Vertraulichkeit und IT-Sicherheit',
        aReportCanBeMadeEither:
            'Eine Meldung kann entweder anonym oder vertraulich erfolgen. Im ersten Fall werden keine persönlichen Informationen weitergegeben, im zweiten Fall muss der Hinweisgeber persönliche Informationen weitergeben. Wenn Sie in Ihrer Meldung personenbezogene Informationen weitergeben, haben nur die zur Untersuchung des Falles befugten Personen Zugang zu diesen Informationen. Die Vertraulichkeit der eingereichten Meldung wird daher auf jeden Fall gewahrt.',
        theWhistleblowerReportingChannel:
            'Der Whistleblower-Meldekanal wird von Walor ApS betrieben, einer unabhängigen dritten Partei, die die Sicherheit des Systems garantiert. Das System protokolliert keine IP-Adressen und Maschinen-IDs und verschlüsselt alle verarbeiteten Daten. Nur der zuständige Sachbearbeiter hat Zugriff auf die Meldung.',
        noticeOfPersonConcerned: 'Mitteilung an die betroffene Person',
        theRecipientOfTheReport:
            'Der Meldeempfänger ist verpflichtet, der gemeldeten Person Auskunft über das gemeldete Ereignis zu erteilen. In jedem Einzelfall wird geprüft, wann diese Mitteilung weitergegeben werden kann, damit die Mitteilung keine Auswirkungen auf die Beweiserhebung hat.',
        noInformationEitherDirect:
            'Es werden weder direkt noch indirekt Angaben darüber gemacht, wer die Meldung an die betreffende Person gemacht hat, selbst wenn der Meldende sich für eine vertrauliche Meldung entschieden hat.',
        questions: 'Fragen',
        allQuestions:
            'Alle Fragen zur Whistleblower-Regelung können an folgende Adresse gerichtet werden',
    },
    newCaseFlow: {
        orisExtraText: 'BS keine personenbezogenen Daten zu Patienten',
        headerInitiateReport: 'Bericht einleiten',
        headerDescription: 'Beschreibung',
        headerChooseCaseworker: 'Sachbearbeiter wählen',
        headerSummary: 'Zusammenfassung',
        initiateReport: 'Bericht einleiten',
        howWouldYouLikeToAppear: 'Wie möchten Sie in dem Bericht erscheinen?',
        or: 'oder',
        confidential: 'Vertraulich',
        whatIstheDifferenceBetweenAnAnonymous:
            'Was ist der Unterschied zwischen einer anonymen und einer vertraulichen Meldung?',
        popUpWhatIstheDifferenceBetweenAnAnonymous:
            'Was ist der Unterschied zwischen einer anonymen und einer vertraulichen Meldung?',
        popUpAnonymous: 'Anonym',
        popUpAnonymousYouProvideYourEmployer:
            'Sie stellen Ihrem Arbeitgeber Informationen über das mögliche Fehlverhalten, den beobachteten Vorfall oder Unfall zur Verfügung, müssen aber KEINE Angaben zu Ihrer Person machen.',
        popUpConfidential: 'Vertraulich',
        popUpConfidentialYouProvideYourEmployer:
            'Sie informieren Ihren Arbeitgeber sowohl über das mögliche Fehlverhalten, den beobachteten Vorfall oder Unfall als auch über einige Informationen zu Ihrer Person.',
        confidentialInformation: 'Vertrauliche Informationen',
        provideYourPersonalInformation:
            'Geben Sie Ihre persönlichen Daten für den Bericht an',
        secretInformationNote:
            'Ihre Angaben werden geheim gehalten und können nur von der Whistleblower-Stelle eingesehen werden.',
        enterPhone: '12345678',
        describeTheEvents: 'Beschreiben Sie die Ereignisse',
        theMoreDetailedTheDescription:
            'Je detaillierter die Beschreibung ist, desto einfacher ist es, den Fall zu untersuchen',
        allFieldsWith: 'Alle Felder mit * sind Pflichtfelder',
        headline: 'Überschrift *',
        enterHeadline: 'Überschrift',
        description: 'Beschreibung *',
        enterDescription: 'Beschreibung',
        recordAVoice: 'Aufnehmen einer Sprachnachricht',
        recordYourVoice: 'Nehmen Sie Ihre Sprachnachricht auf',
        yourVoiceIsAutomatically:
            'Ihre Stimme wird zur Anonymität automatisch verzerrt',
        listenToYourRecording: 'Hören Sie sich Ihre Aufnahme vor dem Senden an',
        clickToStartRecording: 'Klicken Sie auf , um die Aufnahme zu starten',
        voiceMessage: 'Sprachmitteilung',
        stopRecording: 'Aufnahme beenden',
        addRecording: 'Aufnahme hinzufügen',
        recordedVoiceMessage: 'Aufgezeichnete Sprachnachricht',
        voiceRecording: 'Sprachaufzeichnung',
        uploadFiles: 'Dateien hochladen',
        maximumFileSize: 'Maximale Dateigröße: 100 MB',
        addFiles: 'Dateien hinzufügen',
        youShouldBeAwareThatFilesCanContainMetadata:
            'Sie sollten sich darüber im Klaren sein, dass Dateien Metadaten enthalten können, die möglicherweise Ihre Anonymität gefährden könnten.',
        informationYouCould: 'Informationen, die Sie aufnehmen könnten',
        whereAndWhen: 'Wo und wann hat das Ereignis stattgefunden?',
        whatIsYourKnowledge: 'Was wissen Sie über diesen Fall?',
        whatDepartmentIsInvolved: 'Welche Abteilung ist beteiligt?',
        whatIsYourRelationship:
            'Welche Beziehung haben Sie zu der Organisation?',
        reportSummary: 'Zusammenfassung des Berichts',
        summaryCaseWorker: 'Wer wird den Bericht erhalten?',
        summaryHowWouldYouLikeToAppear:
            'Wie möchten Sie in dem Bericht erscheinen?',
        summaryHeadline: 'Überschrift',
        summaryDescription: 'Beschreibung',
        summaryFiles: 'Dateien',
        expectToRecieveAnAnswer:
            'Erwarten Sie innerhalb von 7 Tagen eine Antwort',
        submitReport: 'Bericht einreichen',
        theReportHasBeenReceived: 'Der Bericht ist eingegangen',
        inOrderToAccessYourCaseAgain:
            'Um wieder auf Ihren Fall zugreifen zu können, müssen Sie den Whistleblower-Code speichern und sicher aufbewahren, da dies die einzige Möglichkeit ist, wieder auf Ihren Fall zuzugreifen.',
        keepItSafe:
            'Bewahren Sie es sicher auf und geben Sie es nicht an andere weiter.',
        whistleblowerCode: 'Whistleblower-Kodex',
        copyToClipboard: 'Code kopieren',
        stayUpdated: 'Informiert bleiben',
        youHaveTheOpportunityToReceiveAMail:
            'Sie erhalten Aktualisierungen, indem Sie Ihre E-Mail-Adresse eingeben.',
        itIsImportantToMention: 'Ihre E-Mail wird nicht weitergegeben.',
        theWhistleblowerCodeWillNot:
            'Der Whistleblower-Kodex wird NICHT per Post verschickt',
        email: 'Ihre E-Mail Addresse',
        chooseContactFrame: {
            pickYourCaseworker: 'Wählen Sie Ihren Sachbearbeiter',
            pickExcludedCaseworker:
                'Sachbearbeiter, die den Bericht erhalten werden',
            theContactWill: 'Die ausgewählte Kontaktperson erhält den Bericht',
            theContactWillNot:
                'Sachbearbeiter, die den Bericht erhalten werden',
            languages: 'Sprachen',
            languagesNotGiven: 'Nicht angegebene Sprachen',
            pickCaseworker: 'Sachbearbeiter auswählen',
        },
        popUpRememberYourWhistleblowerCode:
            'Erinnern Sie sich an Ihren Whistleblowing-Kodex',
        popUpItIsImportantThatYouSaveAndStoreTheWhistleblowerCode:
            'Es ist wichtig, dass Sie den Whistleblower-Code speichern und aufbewahren, damit Sie auch in Zukunft auf den Fall zugreifen können.',
    },
    accessCaseFlow: {
        date: 'Datum',
        files: 'Dateien',
        accessExistingReport: 'Zugriff auf bestehenden Bericht',
        inOrderToAccessYourCase:
            'Verwenden Sie den erhaltenen Whistleblower-Code, um auf Ihre bestehende Meldung zuzugreifen.',
        missingCode: 'Haben Sie Ihren Code verloren?',
        createNewRaport: 'Bitte erstellen Sie einen neuen Bericht.',
        enterYourWhistleblowerCode: 'Geben Sie Ihren Whistleblower-Code ein',
        enterCode: 'Code eingeben',
        logout: 'Abmelden',
        info: 'Info',
        id: 'ID',
        appearance: 'Erscheinungsbild',
        caseworkers: 'Sachbearbeiter',
        fromWhistleblower: 'Vom Whistleblower',
        fromCaseworker: 'Vom Sachbearbeiter',
        timeline: 'Zeitleiste',
        description: 'Beschreibung',
        messages: 'Nachrichten',
        translate: 'Übersetzen Sie',
        translated: 'Übersetzt',
        anonymous: 'Anonym',
        enterMessage: 'Nachricht eingeben',
        send: 'Send',
        logoutOfReport: 'Abmeldung vom Bericht',
        hiddenMsgOne: 'Dies ist das Datum, an dem der Bericht erstellt wurde.',
        hiddenMsgTwo:
            'Dies ist die Frist für die erste Antwort des Sachbearbeiters an Sie',
        hiddenMsgThree:
            'Dies ist die Frist für die Rückmeldung des Sachbearbeiters an Sie',
        months: {
            january: 'Januar',
            february: 'Februar',
            march: 'März',
            april: 'April',
            may: 'Mai',
            june: 'Juni',
            july: 'Juli',
            august: 'August',
            september: 'September',
            october: 'Oktober',
            november: 'November',
            december: 'Dezember',
        },
    },
    header: {
        dashboard: 'Dashboard',
        cases: 'Fälle',
        clients: 'Kundinnen und Kunden',
        notifications: 'Benachrichtigungen',
        readAll: 'Alles lesen',
    },
    dashboardPartner: {
        headlineDashboard: 'Dashboard',
        yourcases: 'Ihre Fälle',
        headline: 'Überschrift',
        notifications: 'Benachrichtigungen',
        all: 'Alle',
        unread: 'Ungelesen',
        noCases: 'Sie haben keine Fälle',
        noNotifications: 'Sie haben keine Benachrichtigungen',
        yourStatistics: {
            yourStatistics: 'Ihre Statistiken',
            open: 'Öffnen',
            closed: 'Geschlossen',
            forwarded: 'Weitergeleitet',
            totalCases: 'Gesamte Fälle',
            activeCases: 'Aktive Fälle',
            closedCases: 'Abgeschlossene Fälle',
            forwardedCases: 'Weitergeleitete Fälle',
        },
    },
    casesPartner: {
        headlineCases: 'Fälle',
        allCases: 'Alle Fälle',
        headline: 'Überschrift',
        status: 'Status',
        filter: 'Filters',
        removeFilter: 'Filter entfernen',
        myCases: 'Meine Fälle',
        actionRequired: 'Erforderliche Maßnahmen',
        awaitingResponse: 'Erwartet eine Antwort',
        seeClosedCases: 'Abgeschlossene Fälle anzeigen',
        viewForwardedCases: 'Weitergeleitete Fälle anzeigen',
        forwardedCases: 'Weitergeleitete Fälle',
        searchCases: 'Suche nach Fällen',
        headlineClosedCases: 'Abgeschlossene Fälle',
        closedCases: 'Abgeschlossene Fälle',
    },
    caseworkerOpenReport: {
        transcription: 'Transkription',
        goBack: 'Zurückgehen',
        reportBy: 'Bericht von',
        days: 'Tage',
        deadlineExceededTagOne: 'Frist überschritten um',
        deadlineExceededTagTwo: 'Gesetzliche Frist eingehalten',
        hours: 'Stunden',
        thisReportHasBeen: 'Dieser Bericht wurde übermittelt von',
        sevenDaysMessageOne:
            'Sie müssen innerhalb von 7 Tagen nach Erhalt einer Meldung eine Empfangsbestätigung ausstellen.',
        sevenDaysMessageTwo:
            'Senden Sie eine Nachricht an den unten stehenden Whistleblower und halten Sie sich an das Gesetz.',
        ninetyDaysMessageOne:
            'Der Hinweisgeber sollte so schnell wie möglich eine Rückmeldung erhalten, spätestens jedoch drei Monate nach der Bestätigung des Eingangs der Meldung.',
        ninetyDaysMessageTwo:
            'Ein Feedback kann zum Beispiel der Plan für oder das Ergebnis einer internen Untersuchung sein.',
        deadlinePassed: 'Frist ist abgelaufen.',
        deadlinePassedMessage:
            'Die 3-Monats-Frist ist abgelaufen. Bitte stellen Sie sicher, dass dem Hinweisgeber eine Rückmeldung gesendet wurde, und falls nicht, senden Sie diese bitte so schnell wie möglich.',
        acknowledgmentDeadlinePassedMessage:
            'Die 7-Tage-Frist ist abgelaufen. Bitte stellen Sie sicher, dass dem Hinweisgeber eine Empfangsbestätigung gesendet wurde, und falls nicht, senden Sie diese bitte so schnell wie möglich.',
        exportCase: 'Exportieren',
        editInformation: 'Informationen bearbeiten',
        changeResponsibility: 'Verantwortlich ändern',
        theNewResponsible:
            'Der neue Verantwortliche wird per E-Mail benachrichtigt',
        thereAreNoOther: 'Es sind keine weiteren Sachbearbeiter verfügbar',
        forward: 'Weiterleiten',
        title: 'Titel',
        uncategorized: 'Uncategorized',
        categorizeCase: 'Fall kategorisieren',
        selectCategory: 'Wählen Sie eine Kategorie für diesen Fall',
        selectedCategory: 'Ausgewählte Kategorie',
        close: 'Schließen',
        saveThis: 'Speichern',
        frequentCategories: 'Häufige Kategorien',
        allCategories: 'Alle Kategorien',
        ViewMoreCategories: 'Weitere Kategorien anzeigen',
        ViewLess: 'Weniger sehen',
        status: 'Status',
        changeStatus: 'Status ändern',
        youAreInTheProcess: 'Sie sind gerade dabei, den Status zu ändern',
        awaitingResponse: 'Erwartet eine Antwort',
        actionRequired: 'Erforderliche Maßnahmen',
        confirm: 'Bestätigen Sie',
        caseDescription: 'Beschreibung',
        noFilesUploaded: 'Keine Dateien hochgeladen',
        historyLog: 'Logbuch Geschichte',
        preferredContact: 'Bevorzugter Kontakt',
        noMessages: 'Keine Meldungen',
        internalNotes: 'Interne Notizen',
        takeNotesHere:
            'Fügen Sie hier Ihre Notizen ein, damit Sie nichts vergessen',
        onlyTheCaseworkers: 'Dies ist nur für die Sachbearbeiter sichtbar',
        enterNote: 'Notiz schreiben',
        saveNote: 'Speichern',
        closeCase: 'Fall schließen',
        solved: 'Gelöst',
        denied: 'Abgelehnt',
        forwarded: 'Weitergeleitet',
        addComment: 'Kommentar hinzufügen',
        forwardedAt: 'Weitergeleitet am',
        severityScore: 'Schweregrad',
        comment: 'Kommentar',
        theCaseHasBeenForwardedTo: 'Der Fall wurde weitergeleitet an',
        theCaseHasBeenForwardedBy: 'Der Fall wurde weitergeleitet von',
        caseClosed: 'Fall abgeschlossen',
        toEnsureGDPR:
            'Um die Einhaltung der GDPR-Richtlinie zu gewährleisten, wird dieser Fall dauerhaft gelöscht in',
        theOptionToExportTheCase:
            'Innerhalb dieses Zeitrahmens besteht die Möglichkeit, den Fall als PDF-Datei zu exportieren.',
        theDeletionOfTheCaseWillNot:
            'Die Löschung des Falles hat keinen Einfluss auf Ihre Statistikübersicht.',
        caseworkerPopup: {
            editCaseworker: 'Sachbearbeiter bearbeiten',
            close: 'Schliessen',
            caseworkerInCharge: 'Zuständiger Sachbearbeiter',
            newFlag: 'Neu',
            addCaseworkers: 'Sachbearbeiter hinzufügen',
            noCaseworkerAvailable:
                'Es gibt keine anderen verfügbaren Sachbearbeiter, die diesem Fall zugewiesen werden könnten.',
            discardChanges: 'Änderungen verwerfen',
        },
    },
    caseClosedViewPartner: {
        closeDate: 'Datum des Abschlusses',
        comment: 'Kommentar',
        readMore: 'Mehr lesen',
        noComment: 'Kein Kommentar',
        automaticDelation: 'Automatisches Löschen',
        exportCase: 'Fall exportieren',
        caseWillBePermanentlyDeleted:
            'Zur Einhaltung der GDPR-Vorschriften wird dieser Fall dauerhaft gelöscht.',
    },
    clientsPartner: {
        headlineClients: 'Kundinnen und Kunden',
        buttonAddNewClient: 'Neuen Kunden hinzufügen',
        allClients: 'Alle Kunden',
        name: 'Name',
        openCases: 'Offene Fälle',
        closeCases: 'Abgeschlossene Fälle',
        newCases: 'Neue Fälle',
    },
    singleClientViewPartner: {
        information: 'Informationen',
        lineOfContact: 'Sachbearbeiter',
        cases: 'Fälle',
        buttonSave: 'Speichern',
        saveOrderOfContacts: 'Reihenfolge der Kontakte speichern',
        lineOfContactsHaveNot: 'Sachbearbeiter wurden noch nicht hinzugefügt',
        deleteCaseworker: 'Sachbearbeiter löschen',
        youAreAboutToDeleteTheCaseworker:
            'Sie sind dabei, den Sachbearbeiter zu löschen',
        theCaseworkerWillNotAbleToReceive:
            'Der Sachbearbeiter kann in Zukunft keine Berichte mehr erhalten.',
        theCaseworkerCannotBeDeletedIf:
            'Der Sachbearbeiter kann nicht gelöscht werden, wenn er mit einem offenen Fall verbunden ist.',
        thisActionCannotBeUndone:
            'Diese Aktion kann nicht rückgängig gemacht werden',
        caseworkerHasCasesAndCannotBeDeleted:
            'Der Sachbearbeiter hat einen oder mehrere aktive Fälle und kann nicht gelöscht werden',
        contactAdded: 'Es wurde ein neuer Sachbearbeiter eingestellt',
        contactUpdated: 'Sachbearbeiter aktualisiert',
        inviteCaseworker: 'Sachbearbeiter einladen',
        assignCaseworker: 'Sachbearbeiter zuweisen',
        noAvailableCaseworkers: 'Keine verfügbaren Sachbearbeiter zum Zuweisen',
        unassignCaseworker: 'Zuweisung aufheben',
        youAreAboutToUnassign:
            'Möchten Sie die Zuweisung wirklich aufheben für',
        confirmUnassign: 'Zuweisung aufheben',
        allCases: 'Alle Fälle',
        company: 'Unternehmen',
        headline: 'Überschrift',
        status: 'Status',
        actionRequired: 'Erforderliche Maßnahmen',
        awaitingResponse: 'Erwartet eine Antwort',
        reOpenCase: 'Fall wieder aufnehmen',
        youAreInTheProcessOfExporting:
            'Sie sind gerade dabei, einen Fall zu exportieren',
        youAreInTheProcessOfReopening:
            'Sie sind im Prozess der Wiederaufnahme des Falles',
        caseInfo: 'Infos zum Fall',
        arrivalDate: 'Datum der Ankunft',
        closeDate: 'Datum des Abschlusses',
        caseID: 'Fall-ID',
        theInternalInvestigationHasConcluded:
            'Die interne Untersuchung ist abgeschlossen und der Fall wird in der nächsten Woche gelöscht.',
        addLanguage: 'Sprache hinzufügen',
        searchLanguage: 'Sprache suchen',
        languageNotFound: 'Sprache nicht gefunden',
    },
    addNewClientPartner: {
        headlineAddNewClient: 'Neuen Kunden hinzufügen',
        buttonCancel: 'Abbrechen',
        searchForCompanyNameOrCompanyNumber:
            'Suche nach Firmenname oder Firmennummer',
        findCompany: 'Unternehmen finden',
        enterInformationManually: 'Informationen manuell eingeben',
        thanksForYourSubscription: 'Sie haben einen neuen Kunden hinzugefügt',
        informationOnHowToGetStarted:
            'Informationen darüber, wie der Kunde loslegen kann',
        linkText:
            'Über den Link erhalten Sie Zugang zum digitalen Meldekanal für Hinweisgeber, wo die Meldungen erstellt und eingereicht werden können. Teilen Sie dies mit dem Kunden.',
        employeeLink: 'Mitarbeiter-Link',
        whistleblowerPolicyText:
            'Finden Sie die Whistleblower-Richtlinie des Kunden unten und verweisen Sie den Kunden darauf, sich auf der Plattform anzumelden, um zusätzliches Material zu erhalten.',
        whistleblowerPolicy: 'Whistleblower-Politik',
        download: 'Herunterladen',
        sendLinkText: 'Senden Sie die Informationen an Ihren Kunden',
        buttonSendEmail: 'E-Mail senden',
        backToClients: 'Zurück zu Kunden',
        popUpSendEmail: 'E-Mail senden',
        popUpText:
            'Sie sind im Begriff, den Link zum Whistleblower-Meldekanal und die Whistleblower-Richtlinie zu senden an',
        popUpButtonSendInformation: 'Informationen senden',
        popUpAreYouSureYouWantToCancelThisSession:
            'Sind Sie sicher, dass Sie diese Sitzung abbrechen möchten?',
        popUpYouWillLoseAllYourProgress:
            'Sie verlieren Ihren gesamten Fortschritt',
        popUpButtonNo: 'Nein',
        popUpButtonYes: 'Ja',
    },
    settingsPartner: {
        headlineSettings: 'Einstellungen',
        myAccount: 'Mein Konto',
        automaticReply: 'Automatische Antwort',
        billing: 'Rechnungsstellung',
        users: 'Benutzer',
        logOut: 'Abmelden',
        edit: 'bearbeiten',
        changePassword: 'Passwort ändern',
        oldPassword: 'Altes Passwort',
        newPassword: 'Neues Passwort',
        passwordUpdate: 'Erledigt!',
        passwordUpdadetSuccessfully: 'Passwort erfolgreich aktualisiert.',
        defaultLanguage: 'Standardsprache',
        emailUpdated: 'E-Mail aktualisiert!',
        invoices: 'Rechnungen',
        verificationLinkSent:
            'Wir haben einen Verifizierungslink an die neue E-Mail geschickt. Sie werden abgemeldet in',
        seconds: 'Sekunden.',
        reactivateAutoReply: 'Automatische Antwort reaktivieren',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        autoReplyAlertMessage:
            'Die automatische Antwort wird 15 Minuten nach Erhalt der Meldung gesendet.',
        added: 'Hinzugefügt',
        openCases: 'Offene Fälle',
        closedCases: 'Abgeschlossene Fälle',
        buttonAddNewUser: 'Neuen Benutzer hinzufügen',
        popUpAddingANewUser: 'Hinzufügen eines neuen Benutzers',
        popUpAddPhoto: 'Foto hinzufügen',
        popUpChangePhoto: 'Foto ändern',
        popUpText:
            'Der Nutzer muss sein Konto durch eine Aktivierungs-E-Mail verifizieren',
        popUpButtonAddUser: 'Benutzer hinzufügen',
        myAccountFrame: {
            somethingWentWrong:
                'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            yourChangesHaveBeen:
                'Ihre Änderungen wurden erfolgreich gespeichert',
        },
        oldAddPaymentMethodFrame: {
            paymentMethods: 'Abrechnung',
            addPaymentMethod: 'Zahlungsmethode hinzufügen',
            defaultPaymentMethod: 'Standard-Zahlungsmethode',
            yourDefaultPaymentMethod:
                'Die Standardzahlungsmethode wird für alle zukünftigen Zahlungen verwendet. Wenn eine Abonnementgebühr fällig ist, werden wir versuchen, diese automatisch zu belasten.',
            defaultPaymentMethodMissing: 'Die Standardzahlung fehlt.',
            otherPaymentMethods: 'Andere Zahlungsmethoden',
            otherPaymentMethodsYouHave:
                'Andere Zahlungsmethoden, die Sie hinzugefügt haben. Markieren Sie diejenige, die Sie als Standard verwenden möchten',
            currentPlan: 'Aktueller Plan',
            belowYouCanSee: 'Hier sehen Sie das ausgewählte Abonnement.',
            cardNumber: 'Kartenummer',
            expireDate: 'Verfallsdatum',
            addPaymentMethodModal: {
                addPaymentMethod: 'Zahlungsmethode hinzufügen',
                cancel: 'abbrechen',
                card: 'Karte',
                invoice: 'Rechnung',
                errorLoadingStripe: 'Fehler beim Laden von Stripe',
                fullName: 'Voll Name',
                email: 'E-Mail',
                address: 'Adresse',
                city: 'Stadt',
                zipCode: 'Post Nummer',
                bankInformation: 'Bankangaben',
                cardInformation: 'Karteninformation',
                loginMessage:
                    'Dies kann einige Minuten dauern. Bitte haben Sie Geduld.',
            },
        },
        addPaymentMethodFrame: {
            creditOrDebit: 'Kredit- oder Debitkarte',
            invoice: 'Rechnung',
            addACard: 'Eine Karte als Zahlungsmethode hinzufügen',
            useAnInvoice: 'Verwenden Sie eine Rechnung als Zahlungsmethode',
            active: 'Aktiv',
            freeTrial: 'Kostenloser Versuch',
            canceled: 'Abgesagt',
            manageSubscription: 'Abonnement verwalten',
            addPaymentMethod: 'Zahlungsmethode hinzufügen',
            reactiveSubscription: 'Abonnement reaktivieren',
            cancelSubscription: 'Abonnement kündigen',
            youCanCancel:
                'Sie können Ihr Abonnement jederzeit kündigen. Sie haben weiterhin Zugang zu Ihrem Konto, bis Ihr aktueller Abrechnungszeitraum endet.',
            needHelp: 'Brauchen Sie hilfe',
            areYouSure:
                'Sind Sie sicher, dass Sie Ihr Abonnement kündigen möchten?',
            pleaseLetUsKnow:
                'Bitte lassen Sie uns wissen, wenn Sie ein bestimmtes Anliegen haben, das wir vor Ihrer Abreise klären können.',
            ifYourCertain:
                'Wenn Sie sich sicher sind, dass Sie stornieren möchten, sind wir für Sie da, wenn Sie bereit sind, zurückzukehren.',
            noGoBack: 'Nein, geh zurück',
            itIsToo: 'Es ist zu teuer',
            weDidNotUse: 'Wir haben die Plattform nicht genutzt',
            other: 'Andere',
            whyAreYouCanceling: 'Warum stornieren Sie',
            yourSubscriptionHasBeen: 'Ihr Abonnement wurde gekündigt',
            yourPlanIsActiveUntil: 'Ihr Plan ist aktiv bis',
            youWillContinue:
                'Bis dahin haben Sie weiterhin Zugang zu Ihrem Konto.',
            editPaymentMethod: 'Zahlungsmethode bearbeiten',
            currentPaymentMethods: 'Derzeitige Zahlungsmodalitäten',
            chooseAnotherMethod: 'Wählen Sie eine andere Methode',
            paymentFailed: 'Zahlung fehlgeschlagen',
            yourPaymentHasFailed: 'Ihre Zahlung ist fehlgeschlagen',
            theInvoiceHasNotBeenPayed: 'Die Rechnung wurde nicht beglichen',
            doYouNeedHelp: 'Brauchen Sie Hilfe?',
            weWillGetInContact:
                'Wir werden uns innerhalb von 2 Stunden mit Ihnen in Verbindung setzen.',
            talkToYouSoon: 'Wir sprechen uns bald',
            getBack: 'Zurückholen',
            submit: 'Einreichen',
            day: 'Tag',
            days: 'Tage',
            yourCardHasExpired: 'Ihre Karte ist abgelaufen',
            pdf: 'PDF',
            whistleblowingSoftware: 'Whistleblowing-Software',
            amount: 'Betrag',
            back: 'Zurück',
            subscription: 'Abonnement',
            chooseThePlanThat:
                'Wählen Sie den Plan, der der Gesamtzahl der Mitarbeiter in Ihrem Unternehmen entspricht.',
            employees: 'Mitarbeiter',
            year: 'Jahr',
            currentPlan: 'Aktueller Plan',
            newPlan: 'Neuer Plan',
            choosePlan: 'Plan auswählen',
        },
        invoicesFrame: {
            billingHistory: 'Geschichte der Rechnungsstellung',
            invoice: 'Rechnung',
            amount: 'Betrag',
            plan: 'Plan',
            status: 'Status',
            paid: 'Bezahlt',
            waitingToPay: 'Warten auf die Bezahlung',
            download: 'Herunterladen',
        },
        userInformation: 'Benutzerinformationen',
    },
    clientView: {
        information: 'Informationen',
        lineOfContact: 'Sachbearbeiter',
        customization: 'Personalisierung',
        whistleblowerPolicy: 'Whistleblower-Politik',
        reportingChannel: 'Meldekanal',
        copyLinkReportingChannel: 'Kopieren Sie den Link zu Ihrem Meldekanal',
        downloadQRCodeImage: 'Bild hier herunterladen',
        downloadQRCode: 'Download Meldekanal QR-Code',
        copyLinkWhistleblowerPolicy:
            'Link zu Ihrer Whistleblower-Richtlinie kopieren',
        reportingChannelLanguage: 'Sprache des Meldekanals:',
        reportingChannelLanguageError: 'Fehler in der Kanalsprache melden:',
        qrCode: 'QR-Code',
        trainingMaterial: 'Trainingsmaterial',
        copyLinkToTrainingMaterial: 'Link zu Ihrem Trainingsmaterial kopieren',
        workEmail: 'Arbeits-E-Mail',
        phone: 'Telefon',
        address: 'Adresse',
        numberOfEmployees: 'Anzahl mitarbeitern',
        contactPerson: 'Kontaktperson',
        willBeDisplayedReportLink:
            'Die nachstehenden Informationen werden dem Hinweisgeber über den Meldelink angezeigt',
        languages: 'Sprachen',
        notes: 'Anmerkungen',
        preview: 'Vorschau',
        pickYourCaseworker: 'Wählen Sie Ihre Sachbearbeiter',
        theContactWill: 'Die ausgewählten Sachbearbeiter erhalten den Bericht',
        note: 'Hinweis',
        editProfilePicture: 'Profilbild bearbeiten',
        addPhoto: 'Foto hinzufügen',
        changePhoto: 'Foto ändern',
        addQuestion: 'Frage hinzufügen',
        reportQuestions: 'Fragen zum Bericht',
        addAQuestion: 'Fügen Sie Ihre eigenen Fragen hinzu',
        questionOnReportingChannel: 'Fragen zu Ihrem Meldekanal',
        dragToChangeOrderOfQuestions:
            'Hier können Sie die Reihenfolge der Fragen ändern.',
        saveOderOfQuestions: 'Reihenfolge der Fragen speichern',
        industrySuggestedQuestionTitle:
            'Hier finden Sie einige empfohlene Fragen, die speziell auf Ihre Branche zugeschnitten sind.',
        suggestedQuestionText:
            'Diese Zitate beziehen sich auf Ihre Branche. Nutzen Sie sie, lassen Sie sich inspirieren oder lassen Sie sie einfach weg.',
        addQuestionModal: {
            addingANewQuestion: 'Eine neue Frage hinzufügen',
            newQuestion: 'Neue Frage',
            addQuestion: 'Frage hinzufügen',
        },
    },
    verifyEmail: {
        verifyEmail: 'E-Mail verifizieren',
        emailVerified: 'E-Mail geprüft',
        yourEmailHasBeen:
            'Ihre E-Mail wurde verifiziert. Sie können sich nun auf der Anmeldeseite mit Ihrer E-Mail und Ihrem neu erstellten Passwort anmelden.',
        goToLogin: 'Zur Anmeldung gehen',
        verifyNewEmail: 'Geprüft!',
        loginWithNewEmail:
            'Sie können sich jetzt mit der neuen E-Mail anmelden.',
    },
    nextButton: {
        nextStep: 'Weiter',
    },
    finishButton: {
        finish: 'fertigstellen',
    },
    closeButton: {
        close: 'Schließen',
    },
    dropdown: {
        countryNotFound: 'Land nicht gefunden',
    },
    copiedText: {
        copied: 'Kopiert',
    },
    you: {
        you: 'Sie',
    },
    warningText: {
        warning: 'Warnung',
    },
    deleteText: {
        delete: 'Löschen',
    },
    inactiveModal: {
        inactivityWarning: 'Warnung vor Inaktivität',
        youWillBeLoggedOut: 'Sie werden abgemeldet',
        youHaveBeenInactive:
            'Sie sind seit 14 Minuten inaktiv. Wenn der Timer abläuft, werden Sie abgemeldet',
        stayLoggedIn: 'Eingeloggt bleiben',
    },
    notifications: {
        newMessage: 'Neue Nachricht',
        deadlineAlert: 'Deadline-Alarm',
        newReport: 'Neuer Bericht',
        reportAssigned: 'Zugewiesener Bericht',
        reportUnassigned: 'Bericht nicht zugewiesen',
    },
    historyLog: {
        forwarded: 'Weitergeleitet',
        exported: 'Exportiert',
        changeResponsible: 'Verantwortlich ändern',
        caseViewed: 'Fall betrachtet',
        fileUploaded: 'Datei hochgeladen',
        newMessage: 'Neue Nachricht',
        statusUpdated: 'Status aktualisiert',
        caseDelegation: 'Fall Delegation',
        reportCreated: 'Bericht erstellt',
        to: 'zu',
        by: 'von',
        from: 'von',
        caseHasBeenForwarded: 'Der Fall wurde weitergeleitet',
        caseHasBeenExported: 'Der Fall wurde exportiert',
        caseHasBeenReassigned: 'Der Fall wurde neu zugewiesen',
        caseHasBeenViewed: 'Der Fall wurde angesehen',
        categoryIsChanged: 'Kategorie wird geändert',
        messageFrom: 'Nachricht von',
        caseAssigned: 'Zugewiesener Fall',
        newCase: 'Neuer Fall',
        caseClosed: 'Der Fall wurde abgeschlossen',
        caseClosedBy: 'Dieser Fall wurde abgeschlossen von',
        caseReopened: 'Der Fall wurde wieder aufgenommen',
        caseReopenedBy: 'Dieser Fall wurde wieder aufgenommen von',
        internalNote: 'Interne Notiz',
        internalNoteHasBeen: 'Interne Notiz wurde geschrieben von',
        caseworkerAdded: 'Sachbearbeiter hinzugefügt',
        caseworker: 'Sachbearbeiter',
        wasAddedBy: 'wurde hinzugefügt von',
        newFile: 'Neue Datei',
        newFileWasAdded: 'Eine neue Datei wurde hinzugefügt von',
        whistleblower: 'Whistleblower',
        automaticReplySent: 'Automatische Antwort gesendet',
        automaticReplyWasSent: 'Automatische Antwort wurde gesendet von',
    },
    validation: {
        nameOfTheCityMustBeAtLeast:
            'Der Name der Stadt muss aus mindestens 1 Zeichen bestehen',
        nameOfTheCityCannot:
            'Der Name der Stadt darf nicht länger als 85 Zeichen sein.',
        companyIdentificationNumberMust:
            'Die Nummer muss genau 8 Zeichen lang sein.',
        addressIsToShort: 'Adresse ist zu kurz',
        addressIsToLong: 'Adresse ist zu lang',
        organizationIsToShort: 'Organisation ist zu kurz',
        organizationIsToLong: 'Organisation ist zu lang',
        mustBeAValidEmail: 'Muss eine gültige E-Mail Adresse sein',
        firstNameCannotBeShorter:
            'Der Vorname darf nicht kürzer als 2 Zeichen sein.',
        firstNameCannotBeLonger:
            'Der Vorname darf nicht länger als 26 Zeichen sein.',
        lastNameCannotBeShorter:
            'Der Nachname darf nicht kürzer als 2 Zeichen sein.',
        lastNameCannotBeLonger:
            'Der Nachname darf nicht länger als 26 Zeichen sein.',
        passwordMustBeAtLeast:
            'Das Passwort muss mindestens 8 Zeichen lang sein.',
        yourPasswordMustContainerAtLeastOneUppercase:
            'Ihr Passwort muss mindestens einen Großbuchstaben enthalten',
        yourPasswordMustContainerAtLeastOneLowercase:
            'Ihr Passwort muss mindestens einen Kleinbuchstaben enthalten',
        yourPasswordMustContainerAtLeastOneSymbol:
            'Ihr Passwort muss mindestens einen symbolischen Buchstaben enthalten',
        yourPasswordMustContainerAtLeastOneNumber:
            'Ihr Passwort muss mindestens eine Zahl und einen Buchstaben enthalten',
        passwordsMustMatch: 'Passwörter müssen übereinstimmen',
        notAValidPhoneNumber: 'Keine gültige Telefonnummer',
        titleOfPositionMustBe:
            'Der Titel der Stelle muss länger als 2 Zeichen sein',
        titleOfPositionCannotBe:
            'Der Titel der Stelle darf nicht länger als 26 Zeichen sein.',
        mustSetAPriority: 'Sie müssen eine Priorität festlegen',
        notAValidZipCode: 'Keine gültige Postleitzahl',
        isLongEnough: 'Mindestens 8 Zeichen lang',
        hasUpperCaseLetter: 'Mindestens 1 Großbuchstabe [A-Z]',
        hasLowerCaseLetter: 'Mindestens 1 Kleinbuchstabe [a-z]',
        hasNumber: 'Mindestens 1 Zahl [0-9]',
        hasSpecialCharacter: 'Mindestens 1 Sonderzeichen[!@#$%^&*()\\-__+.]',
        passwordsMatch: 'Beide Passwörter stimmen überein',
    },
    forwardReportPage: {
        selectCatagory: 'Kategorie auswählen',
        uncategorized: 'Nicht kategorisiert',
        accusationAndEvidenceScore: 'Anschuldigungen und Beweise bewerten',
        accusationScore: 'Anschuldigung Punktzahl',
        evidenceScore: 'Beweiswert',
        severityScore: 'Gesamtwert für den Schweregrad',
        lineOfContact: 'Kontaktlinie',
        lineOfContactReminder:
            'Bitte vergewissern Sie sich, dass die Person auf keinen Fall in diesen Fall verwickelt ist',
        comment: 'Kommentar',
        pleaseLeaveComment: 'Bitte hinterlassen Sie hier einen Kommentar',
        forwardCase: 'Den Fall weiterleiten',
        popUpConfirmForwardPartOne:
            'Sind Sie sicher, dass Sie die folgenden Informationen weiterleiten möchten?',
        popUpConfirmForwardPartTwo: 'zu',
        popUpNo: 'Nein',
        popUpYes: 'Ja, ich bin sicher.',
        minimumAbbreviated: 'Min',
        maximumAbbreviated: 'Max',
        saveThis: 'Dies speichern',
    },
    trialWarning: {
        goToSettings: 'Zu den Einstellungen gehen',
        yourTrialHasEnded: 'Ihre Testphase ist abgelaufen',
        yourFreeTrialEndedOn: 'Ihr kostenloser Testzeitraum endete am:',
        yourFreeTrialEndsOn: 'Die Testphase endet in',
        day: 'Tag',
        days: 'Tage',
    },
    categories: {
        accounting_irregularities: 'Unregelmäßigkeiten in der Buchhaltung',
        bribery: 'Bestechung',
        consumer_protection: 'Verbraucherschutz',
        duty_of_confidentiality: 'Verpflichtung zur Vertraulichkeit',
        embezzlement: 'Veruntreuung',
        extortion: 'Erpressung',
        financial_services_products_and_markets:
            'Finanzdienstleistungen, Produkte und Märkte',
        food_safety_animal_health_and_welfare:
            'Lebensmittelsicherheit, Tiergesundheit und Tierschutz',
        forgery: 'Fälschung',
        fraudulence: 'Betrügereien',
        money_laundering_and_terrorist_financing:
            'Geldwäscherei und Terrorismusfinanzierung',
        occupational_health_and_safety:
            'Gesundheit und Sicherheit am Arbeitsplatz',
        products_safety_and_compliance: 'Produktsicherheit und Konformität',
        protection_of_environment: 'Schutz der Umwelt',
        protection_of_privacy_and_personal_data_and_security_of_network_and_information_systems:
            'Schutz der Privatsphäre und personenbezogener Daten sowie Sicherheit von Netzen und Informationssystemen',
        public_health: 'Öffentliche Gesundheit',
        public_procurement: 'Öffentliches Auftragswesen',
        radiation_protection_and_nuclear_safety:
            'Strahlenschutz und nukleare Sicherheit',
        serious_or_recurring_conflicts_at_the_workplace:
            'Schwere oder wiederkehrende Konflikte am Arbeitsplatz',
        sexual_harassment_and_sexual_assault:
            'Sexuelle Belästigung und sexuelle Übergriffe',
        the_financial_interests_of_the_european_union:
            'Die finanziellen Interessen der Europäischen Union',
        the_internal_market_of_the_european_union_including_state_aid_and_corporate_taxation:
            'Der Binnenmarkt der Europäischen Union, einschließlich staatlicher Beihilfen und Unternehmensbesteuerung',
        theft: 'Diebstahl',
        conflict_of_interest: 'Interessenkonflikt',
        transport_safety: 'Sicherheit im Verkehr',
        non_whistleblower_case: 'Nicht-Whistleblower-Fall',
    },
    integrationModal: {
        thisAppWouldLikeToAccess:
            'Diese App möchte auf Ihr Walor-Konto zugreifen. Dazu müssen Sie die Erlaubnis erteilen',
        thisAppRequires: 'Diese App benötigt die Erlaubnis, um',
        whistleblowingChannel: 'Whistleblowing-Kanal',
        whistleblowingPolicy: 'Whistleblowing-Politik',
        employeeGuides: 'Mitarbeiterleitfäden',
        companyName: 'Firmenname',
        approve: 'Genehmigen Sie',
    },
    dacarpoPolicy: {
        itIsImportant:
            'Es ist wichtig, dass Sie den Whistleblower-Code aus der Meldung speichern, um später auf den Fall zugreifen zu können.',
        allQuestions:
            'Alle Fragen zur Whistleblower-Regelung können an unsere Personalabteilung gerichtet werden.',
        youWillReceive:
            'Sie erhalten innerhalb von sieben Tagen eine Empfangsbestätigung für den Bericht.',
        afterThis: 'Danach wird eine erste Prüfung des Berichts durchgeführt.',
        ifTheReport:
            'Erweist sich die Meldung als besonders unbegründet, wird sie zurückgewiesen. Die Person, die den Fall gemeldet hat, wird hiervon so schnell wie möglich in Kenntnis gesetzt',
        howeverIfTheInitial:
            'Stellt sich jedoch bei der ersten Prüfung heraus, dass die Meldung nicht als besonders unbegründet eingestuft werden kann, wird sie weiter untersucht.',
        theCaseWillThen:
            'Der Fall wird dann intern bearbeitet. Der Hinweisgeber erhält so bald wie möglich eine Rückmeldung über etwaige Aktualisierungen oder Ergebnisse.',
        thisInternalInvestigation:
            'Diese interne Untersuchung kann Folgen für die betroffene(n) Person(en) haben.',
        ifTheCaseIs:
            'Wenn es sich um einen besonders schwerwiegenden Fall handelt, kann der Fall auch an die Polizei zur weiteren Untersuchung weitergeleitet werden.',
        afterConducting:
            'Nach Durchführung aller Untersuchungen und Verhängung möglicher Sanktionen wird der Fall abgeschlossen. Er wird dann aus dem System gelöscht.',
    },
    inviteCaseworkerModal: {
        inviteNewCaseworker: 'Einen neuen Sachbearbeiter einladen',
        sendInvitation: 'Einladung senden',
    },
    caseworkerSetupAccountPage: {
        setupYourWalor: 'Richten Sie Ihr Walor-Konto ein',
        youHaveBeenInvited: 'Sie wurden eingeladen, an der',
        onWalorAs: 'auf Walor als',
        caseworker: 'Sachbearbeiter',
        personalInformation: 'Persönliche Informationen',
        additionalInformation: 'Zusätzliche Informationen',
        preview: 'Vorschau',
        profilePicture: 'Profilbild',
        thisPictureWillAppear:
            'Dieses Bild wird angezeigt, wenn der Hinweisgeber die Sachbearbeiter auswählt.',
        addPicture: 'Bild hinzufügen',
        notes: 'Anmerkungen',
        typeNoteHere: 'Geben Sie hier eine Notiz ein..',
        addLanguages: 'Sprachen hinzufügen',
        languages: 'Sprachen',
        whichDepartmentAreYou: 'In welcher Abteilung sind Sie tätig?',
        chooseOneOption: 'Wählen Sie eine Option',
        humanResources: 'Personalwesen',
        compliance: 'Einhaltung der Vorschriften',
        finance: 'Finanzen',
        operations: 'Betrieb',
        marketing: 'Marketing',
        other: 'Andere',
        pickCaseworker: 'Sachbearbeiter auswählen',
        notesHover: 'Die Hinweise werden dem Hinweisgeber angezeigt',
        languagesHover:
            'Geben Sie an, welche Sprachen Sie sprechen, damit der Hinweisgeber den am besten geeigneten Sachbearbeiter auswählen kann',
    },
    aalborgTeaterPolicy: {
        whistleblowerSchemeEnsuresProtection:
            'Das Whistleblower-Programm gewährleistet den Schutz von Personen, die schwerwiegende Verstöße und Vorfälle melden. Dieses Programm kann in Anspruch genommen werden, wenn Sie solche Verstöße bei',
        theWhistleblowerSchemeCanBeUsed:
            'Das Whistleblower-Programm kann genutzt werden, um Informationen über schwerwiegende Gesetzesverstöße, Versuche, solche Verstöße zu vertuschen, oder andere schwerwiegende Angelegenheiten, die aufgetreten sind oder wahrscheinlich auftreten werden, zu melden.',
        aReportCanBeMadeEither:
            'Ein Bericht kann nur vertraulich sein, was bedeutet, dass der Hinweisgeber personenbezogene Daten offenlegt. Wenn in Ihrem Bericht personenbezogene Daten weitergegeben werden, haben nur diejenigen Zugriff darauf, die zur Untersuchung des Falls befugt sind. Die Vertraulichkeit des eingereichten Berichts wird daher in jedem Fall gewahrt.',
    },
    reusable: {
        voiceRecording: 'Sprachaufzeichnung',
        email: 'E-Mail',
        personalInformation: 'Persönliche Informationen',
        firstName: 'Vornamen',
        lastName: 'Nachname',
        cancel: 'Abbrechen',
        address: 'Adresse',
        city: 'Stadt',
        zipCode: 'Postnummer',
        country: 'Land',
        numberOfEmployees: 'Anzahl der Mitarbeiter',
        phone: 'Rufnummer',
        position: 'Position',
        companyInformation: 'Informationen zum Unternehmen',
        companyNumber: 'Nummer des Unternehmens',
        companyName: 'Name des Unternehmens',
        workEmail: 'Arbeit E-Mail',
        enterWorkEmail: 'Arbeit E-Mail',
        password: 'Passwort',
        anonymous: 'Anonym',
        files: 'Dateien',
        date: 'Date',
        messages: 'Nachrichten',
        organization: 'Organisation',
        new: 'Neu',
        search: 'Suche',
        category: 'Kategorie',
        save: 'Speichern',
        confirmPassword: 'Bestätigen Sie das Passwort',
        name: 'Name',
        closed: 'Geschlossen',
        archived: 'Archiviert',
    },
    customizeWhistleblowerPolicy: {
        whistleblowerPolicy: 'Whistleblower-Politik',
        whistleBlowerPolicyLanguages: 'Sprachen der Whistleblower-Politik',
        reviseTheDefault:
            'Überarbeiten Sie die Standardrichtlinie, bevor Sie Übersetzungen hinzufügen',
        addLanguage: 'Sprache hinzufügen',
        selectALanguage: 'Wählen Sie eine Sprache',
        translations: 'Übersetzungen',
        default: 'Standard',
        deleteLanguage: 'Sprache löschen',
        youAreAboutToDelete:
            'Sie sind im Begriff, die Formulierung der Whistleblowing-Richtlinie zu löschen',
        noGoBack: 'Nein, geh zurück',
        restoreDefaultPolicy: 'Standardrichtlinie wiederherstellen',
        youAreAbout:
            'Sie sind dabei, die standardmäßige Whistleblowing-Politik wiederherzustellen!',
        anyModifications:
            'Änderungen an der englischen Übersetzung werden außer Kraft gesetzt.',
        restoreToDefault: 'Wiederherstellen der Standardeinstellungen',
        youHaveTheOption:
            'Hier haben Sie die Möglichkeit, Korrekturen an Ihrer Whistleblower-Richtlinie vorzunehmen. Wenn Sie Änderungen an der Standardrichtlinie vornehmen, müssen Sie die Richtlinie in die Sprachen übersetzen, die Sie unterstützen möchten. Sie können das automatische Übersetzungswerkzeug unten verwenden und diese bearbeiten.',
        autoTranslate: 'Automatisch übersetzen',
        addMoreLanguages: 'Weitere Sprachen hinzufügen',
    },
    clientsPage: {
        clients: 'Kunde',
        allClients: 'Alle Kunden',
        addClient: 'Kunde hinzufügen',
    },
    statisticsPage: {
        statistics: 'Statistiken',
        overview: 'Übersicht',
        compareToLastPeriod: 'Vergleich zum letzten Zeitraum',
        noData: 'Keine Daten',
        lastYear: 'Letztes Jahr',
        anonymousVsConfidential: 'Anonym vs Vertraulich',
        actionStats: 'Action-Statistiken',
        avgDaysToFirstResponse: 'Durchschnittliche Tage bis zur ersten Antwort',
        avgDaysToClosedCase:
            'Durchschnittliche Tage bis zum Abschluss des Falls',
        distributionOfCategories: 'Verteilung der Kategorien',
        casesByMonth: 'Fälle nach Monat',
        months: {
            jan: 'Jan',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Apr',
            may: 'Mai',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Aug',
            sep: 'Sep',
            oct: 'Okt',
            nov: 'Nov',
            dec: 'Dez',
        },
    },
}

export default de
